// src/components/customer/bidHistory/BidHistory.jsx
import React from "react";
import { Trophy, Clock, TrendingDown } from "lucide-react";
import "../../../assets/css/customer/BidHistory/BidHistory.css";

const BidHistory = ({ bids }) => {
  const formatPrice = (price) =>
    new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 0,
    }).format(price);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diff = now - date;

    if (diff < 60000) return "Just now";
    if (diff < 3600000) {
      const m = Math.floor(diff / 60000);
      return `${m} minute${m > 1 ? "s" : ""} ago`;
    }
    if (diff < 86400000) {
      const h = Math.floor(diff / 3600000);
      return `${h} hour${h > 1 ? "s" : ""} ago`;
    }
    if (diff < 604800000) {
      const d = Math.floor(diff / 86400000);
      return `${d} day${d > 1 ? "s" : ""} ago`;
    }

    return date.toLocaleString("en-PK", {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (!bids || bids.length === 0) {
    
    return (
      <div className="bidhist-empty">
        <p className="bidhist-empty-text">No bids placed yet</p>
        <p className="bidhist-empty-subtext">Be the first to place a bid!</p>
      </div>
    );
  }
    const sortedBids = [...bids].sort(
  (a, b) => new Date(b.created_at) - new Date(a.created_at)
);

  return (
    <div className="bidhist-container">
      <div className="bidhist-list">

        {sortedBids.map((bid, index) => {
          console.log(index);
          const isWinning = bid.status === "winning";
          const isOutbid = bid.status === "outbid";

          return (
            <div
              key={bid.id}
              className={`bidhist-card ${isWinning ? "bidhist-card--winning" : ""} ${isOutbid ? "bidhist-card--outbid" : ""}`}
            >
              {/* Rank */}
              <div
                className={`bidhist-rank ${isWinning ? "bidhist-rank--winning" : ""}`}
              >
                {isWinning && index === 0 ? (
                  <Trophy size={15} />
                ) : (
                  <span>#{index + 1}</span>
                )}
              </div>

              {/* Bidder Info */}
              <div className="bidhist-info">
                <div className="bidhist-bidder-row">
                  <span className="bidhist-bidder-name">{bid.adcustomer.fullName}</span>
                  {isWinning && (
                    <span className="bidhist-badge bidhist-badge--winning">
                      Winning
                    </span>
                  )}
                  {isOutbid && (
                    <span className="bidhist-badge bidhist-badge--outbid">
                      Outbid
                    </span>
                  )}
                </div>
                <div className="bidhist-time">
                  <Clock size={12} />
                  {formatDate(bid.created_at)}
                </div>
              </div>

              {/* Amount */}
              <div
                className={`bidhist-amount ${isWinning ? "bidhist-amount--winning" : ""} ${isOutbid ? "bidhist-amount--outbid" : ""}`}
              >
                {formatPrice(bid.bidamount)}
                {isOutbid && (
                  <TrendingDown size={13} className="bidhist-outbid-icon" />
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className="bidhist-footer">
        <span className="bidhist-total">
          {bids.length} {bids.length === 1 ? "bid" : "bids"} placed
        </span>
      </div>
    </div>
  );
};

export default BidHistory;
